import axios from 'axios';
import { getBaseUrlAnalista, ensureProtocol } from '../config/backend';

function getBase() {
  return getBaseUrlAnalista() || ensureProtocol(localStorage.getItem('ipBackend2') || '');
}
function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: token.startsWith('Bearer ') ? token : 'Bearer ' + token } : {};
}

export async function fetchFiltrosSalvos(escopo = 'chamados') {
  const base = getBase();
  if (!base) return [];
  try {
    const res = await axios.get(base + '/filtros', {
      headers: getAuthHeaders(), params: { escopo }, timeout: 15000,
    });
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) { return []; }
}

export async function criarFiltroSalvo(body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/filtros', body, { headers: getAuthHeaders(), timeout: 15000 });
}

export async function atualizarFiltroSalvo(id, body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.put(base + '/filtros/' + id, body, { headers: getAuthHeaders(), timeout: 15000 });
}

export async function removerFiltroSalvo(id) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.delete(base + '/filtros/' + id, { headers: getAuthHeaders(), timeout: 15000 });
}
